export const routes = [
  {
    path: "/orcamento",
    name: "orcamento",
    component: () => import(/* webpackChunkName: "orcamento" */ "./components/Orcamento.vue"),
    meta: { requiresAuth: true },
  },
];
